import $ from 'jquery';
import rivets from 'rivets';
import BaseView from '../../core/baseView';

export default BaseView.extend({

    initialize: function () {
        // do not init if cart is empty
        if (this.$('.js-cart-is-empty').length > 0) {
            return;
        }

        this.binding = rivets.bind(this.el, {
            eventHandlers: this
        });
    },

    rivetsEventHandlers: [
        'removeArticle',
        'changeQuantity',
        'submitParentForm'
    ],

    removeArticle: function (event) {
        this.submitParentForm(event);
    },

    changeQuantity: function (event) {
        this.submitParentForm(event);
    },

    formSubmitEnabled: true,

    submitParentForm: function (event) {
        var $currentTarget = $(event.currentTarget);

        if (this.formSubmitEnabled) {
            $currentTarget.parent().submit();
        }

        this.formSubmitEnabled = false;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/cart/cartView.js
 **/